import { Layout } from "antd";
import Navigation from "../components/Navigation";

const { Header, Content } = Layout;

const MainLayout = ({ collapse = false, children }) => {
  return (
    <Layout>
      <Header className="header">
        <div className="header-content">
          <Navigation withBrand={true} />
        </div>
      </Header>
      <Layout>
        <Content className={`${collapse && "collapse"}`}>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
